import { Attachment } from "./Attachment";
import { Category, CategoryEntity } from "./Category";
import { Player } from "./User";

export interface Question {
  _id?: string;
  title?: string;
  difficulty?: string;
  category?: CategoryEntity;
  subcategoryName?: string;
  attachment?: Attachment;
  uncertainty?: Uncertainty;
  ratings?: Array<string> | Array<Rating>;
  type?: string;
  createdAt?: Date;
}

export enum QuestionType {
  NORMAL = "Normal",
  TYPE_1 = "Video is shown first and only when the video ends then the timer starts. Then the timer starts and the video can be replayed just like the first type",
  TYPE_2 = "Video starts first and when it does it cannot be paused until it ends, once it ends the question is shown and they can not replay the video or anything like that",
}

export interface GivenAnswer {
  isCorrect: boolean;
  byPlayer: string;
}

export interface Rating {
  _id: string;
  player: Player;
  rate: number;
  feedback?: string;
  createdAt: Date;
}

export interface Uncertainty {
  title?: string;
  value?: number;
}

export interface Answer {
  _id?: string;
  question?: string;
  title?: string;
  attachment?: Attachment;
}

export enum Difficulty {
  EASY = "Easy",
  MEDIUM = "Medium",
  HARD = "Hard",
}

export function difficultyStringToDifficulty(d: string): Difficulty {
  switch (d) {
    case "Easy":
      return Difficulty.EASY;
    case "Medium":
      return Difficulty.MEDIUM;
    case "Hard":
      return Difficulty.HARD;
    default:
      return Difficulty.EASY;
  }
}

export interface DifficultyInfo {
  text: string;
  color: string;
  point: number;
}

export interface SubcategoryNumberOfQuestionsModel {
  subcategory: string;
  totalQuestions: number;
  easyDifficultyTotalQuestions: number;
  mediumDifficultyTotalQuestions: number;
  hardDifficultyTotalQuestions: number;
}

export interface GetRandomQuestionRequestModel {
  categoryId: string;
  subcategories: Array<string>;
  difficulty: string;
}

export interface QuestionGiveRatingRequestModel {
  feedback?: string;
  rate: number;
}

// export const sampleQuestions: Array<Question> = [
//   {
//     id: "q1",
//     title: "How old was John F Kennedy when he got elected as the president?",
//     categoryId: "4",
//     subcategory: "furniture",
//     difficulty: Difficulty.EASY,
//   },
//   {
//     id: "q2",
//     title: "How many countries are in Europe?",
//     categoryId: "3",
//     subcategory: "egg",
//     difficulty: Difficulty.MEDIUM,
//   },
//   {
//     id: "q3",
//     title: "What breed of dog is this?",
//     categoryId: "9",
//     subcategory: "must",
//     attachment: {
//       url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/001_American_Pit_Bull_Terrier.jpg",
//       type: AttachmentType.IMAGE,
//     },
//     difficulty: Difficulty.HARD,
//   },
// ];

// export const sampleAnswers: Array<Answer> = [
//   {
//     id: "a1",
//     title: "45",
//     questionId: "q1",
//   },
//   {
//     id: "a2",
//     title: "50",
//     questionId: "q2",
//     attachment: {
//       url: "https://static.vecteezy.com/system/resources/previews/013/709/697/non_2x/europe-countries-flags-flags-of-countries-in-europe-vector.jpg",
//       type: AttachmentType.IMAGE,
//     },
//   },
//   {
//     id: "a3",
//     title: "Pit Bull",
//     questionId: "q3",
//   },
// ];

// export function getQuestionById(id: string | undefined): Question {
//   return sampleQuestions.filter((question) => question.id === id)[0];
// }

// export function getAnswerByQuestionId(questionId: string | undefined): Answer {
//   return sampleAnswers.filter((answer) => answer.questionId === questionId)[0];
// }
